import styled from 'styled-components';

const DoubleImageStyle = styled.div`
	.first_img,
	.second_img {
		margin-bottom: var(--portfolioItemMarg);

		> div {
			padding-top: 59%;
		}
	}

	&.portrait {
		.second_img {
			> div {
				padding-top: 175%;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		&.portrait,
		&.landscape {
			display: flex;
			flex-wrap: wrap;
			margin-right: calc((var(--portfolioItemMarg) / 2) * -1);
			margin-left: calc((var(--portfolioItemMarg) / 2) * -1);

			.first_img,
			.second_img {
				margin-bottom: 0;
				padding-left: calc(var(--portfolioItemMarg) / 2);
				padding-right: calc(var(--portfolioItemMarg) / 2);
			}
		}

		&.right {
			justify-content: flex-end;
		}

		&.portrait {
			align-items: center;

			.first_img {
				flex: 0 0 43%;
			}

			.second_img {
				flex: 0 0 42%;
			}
		}

		&.landscape {
			.first_img {
				flex: 0 0 61%;
			}

			.second_img {
				flex: 0 0 39%;
			}
		}
	}
`;

export default DoubleImageStyle;
